import { Container } from './styled';
import { Message } from './components/Message';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import React, { Component, Fragment } from 'react';

class Chat extends Component {

    static propTypes = {
        messages: PropTypes.array,
        onSendMessage: PropTypes.func,
        theme: PropTypes.object
    };

    static defaultProps = {
        theme: {}
    };
    
    constructor (props) {
        super(props);
        this.state = {
            inputValue: ''
        };
    }

    componentDidMount () {
        this._scrollToBottom();
    }

    componentDidUpdate () {
        this._scrollToBottom();
    }

    _handleSubmitChat = event => {
        event.preventDefault();
        this._handleSendMessage();
    };

    _handleInputValue = ({ target: { value } }) => {
        this.setState({ inputValue: value });
    };

    _handleSendMessage = () => {
        const { onSendMessage } = this.props;
        const { inputValue } = this.state;

        onSendMessage(inputValue);

        this.setState({
            inputValue: ''
        });
    };

    _setContainer = el => {
        this._container = el;
    };

    _scrollToBottom = () => {
        if (this._container) {
            this._container.scrollTop = this._container.scrollHeight;
        }
    };

    render () {
        const { messages } = this.props;
        return (
            <Fragment>
                <Container ref={ this._setContainer }>
                    {
                        messages.map((message, id) => <Message { ...message } key={ id } />)
                    }
                </Container>
            </Fragment>
        );
    }
}

export default withTheme(Chat);
